import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Text } from 'components/vensaComponents';
import { useMyHealthStore } from 'store/mobx/mobx';
import styled from 'styled-components';
import moment from 'moment';

const Icon: React.FC = () => (
  <Box
    width="18px"
    height="18px"
    borderRadius="50%"
    bg="white"
    border="1px solid"
    borderColor="primary"
    justifyContent="center"
    alignItems="center"
    ml="auto"

  >
    <Text color="primary">i</Text>
  </Box>
);


const TooltipBox = styled.span`
  position: absolute;
  top: calc(100% + 10px);
  left: 15px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: max-content;
  max-width: fit-content;
  padding: 8px 8px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 40px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
`

const Label = styled.div`
    font-size: 17px;
    color: #07A3C8;
    width: 100%;
`

const Container = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;

  & ${Label}:hover + ${TooltipBox} {
    visibility: visible;
    color: #fff;
    background-color: #07A3C8;
    width: max-content;
    padding: 8px 8px;
    z-index: 1;
    &:before {
      border-color: transparent transparent #07A3C8
        #07A3C8;
    }
  }
`

const TooltipLine = styled.div`
    font-size: 17px;
    padding: 0.5rem 0;
`

export const BaseSectionItem: React.FC<{
  label: string;
  date?: string;
  tooltipText?: string[];
  displayIcon?: boolean;
}> = observer(({ label, displayIcon = true, date, tooltipText }) => {
  const myHealthStore = useMyHealthStore();

  return (
    <Box
      gap="16px"
      flexWrap="wrap"
      alignItems="center"
      cursor="pointer"
      ml={3}
      mr={3}
      mb="10px"
    >
      <Container>
        <Label>{label} {date ? `(${moment(date).format('DD/MM/YYYY')})` : ''}</Label>
        {tooltipText ? <TooltipBox>
          {tooltipText.length ?? 0 > 0 ? tooltipText.map((item: any) =>
            <TooltipLine>{item}</TooltipLine>
          ) : null}
        </TooltipBox> : null}
        {displayIcon && <div onClick={label === "No records found" ? () => { } : () => {
          myHealthStore.setHealthNavigator({
            keywords: label,
            isOpen: true,
          });
        }}><Icon
        ></Icon></div>}
      </Container>
    </Box>
  );
});
